/* unplugin-vue-components disabled */import { render } from "./CColumn.vue?vue&type=template&id=e3864e68&scoped=true&ts=true"
import script from "./CColumn.vue?vue&type=script&lang=ts"
export * from "./CColumn.vue?vue&type=script&lang=ts"

import "./CColumn.vue?vue&type=style&index=0&id=e3864e68&scoped=true&lang=less"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3864e68"]])

export default __exports__